import React, { useEffect, useState } from "react";
import { ApiURL } from "../../../../../services/apiConstants";
import { post } from "../../../../../services/services";
import SisLoader from "../../../../../widgets/loader";
import IGGDetailsTable from "../../components/CargoCraneCom/IGGRow";

function StaffIGG({ id }) {
  const [loader, setLoader] = useState(false);
  const [filteredData, setFilteredData] = useState([]);

  const fetchIGGList = async () => {
    setLoader(true);
    const formData = new FormData();
    formData.append("ship_id", id);

    try {
      const res = await post(ApiURL.list_ship_igg_details_st, formData);
      if (res?.status === true) {
        setFilteredData(res?.response_data || []);
      }
    } catch (error) {
      console.error("Error fetching IGG list:", error);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchIGGList();
  }, []);

  return (
    <>
      <h3 style={{ margin: "15px 0", fontWeight: "600" }}>Inert Gas Generator (IGG) Information</h3>
      {loader ? (
        <SisLoader />
      ) : filteredData.length > 0 ? (
        <IGGDetailsTable data={filteredData} />
      ) : (
        <p>No data available</p>
      )}
    </>
  );
}

export default StaffIGG;
